import { ActionIcon, Tooltip } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

const WARNING_SECTION_WIDTH = 30;

export interface InlineFieldWarningIconProps {
  message: string;
}

/** Compact field warning — full text in tooltip, not under the field. */
export function InlineFieldWarningIcon({ message }: InlineFieldWarningIconProps): JSX.Element {
  return (
    <Tooltip label={message} multiline maw={300} withArrow position="top-end">
      <ActionIcon
        variant="transparent"
        color="yellow"
        size="sm"
        aria-label={message}
        tabIndex={0}
        style={{ pointerEvents: 'auto' }}
      >
        <IconAlertTriangle size={16} />
      </ActionIcon>
    </Tooltip>
  );
}

export const INLINE_FIELD_WARNING_SECTION_WIDTH = WARNING_SECTION_WIDTH;

export function inlineFieldWarningInputStyles(hasWarning: boolean): Record<string, unknown> | undefined {
  if (!hasWarning) return undefined;
  return {
    input: {
      paddingRight: WARNING_SECTION_WIDTH + 4,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  };
}
